import {Pipe, PipeTransform} from '@angular/core';

import {DimensionItemNode} from '@selpia/dimension-items/data-access';
import {TreeData} from '@selpia/shared/ui';
import {DimensionItem} from '@selpia/shared/models';

@Pipe({
  name: 'treeNode',
  standalone: true,
})
export class TreeNodePipe implements PipeTransform {
  transform(data: DimensionItemNode): TreeData<DimensionItem> {
    return this.#convertItemNodeToTree([data])[0];
  }

  #convertItemNodeToTree(data: DimensionItemNode[]): TreeData<DimensionItem>[] {
    return data.map(item => {
      const {children, element} = item;
      const node: TreeData<DimensionItem> = {
        label: element.name,
        data: element,
        key: element.name,
      };
      if (children) {
        node.children = this.#convertItemNodeToTree(children);
      }
      return node;
    });
  }
}
